// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__qwIhM","disabled":"FileBtn_disabled__32ZbN","warn":"FileBtn_warn__3LOaT","fade":"FileBtn_fade__mQfv4"};